export default "__VITE_ASSET__CnNCKfEY__"